module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dccabc20e9265a2540b4fcb9e044f6ef.png";